import React from 'react';
import { Tooltip } from 'antd';
import { getUnitLabel } from '../../../middleware';
import { showPrice } from '../../../instruments';
import StylesItem from '../m_styles.less';

type IShowRateItem = {
    calculatedRate?: number;
    calculatedRateParent?: number;
    currency?: string;
    rate?: number;
    rateUnitId?: string;
};

export const ShowRateItem: React.FC<IShowRateItem> = ({
    calculatedRate,
    calculatedRateParent,
    currency,
    rate,
    rateUnitId,
}: IShowRateItem) => {
    if (typeof calculatedRate === 'undefined') {
        return null;
    }
    const showRate = `${rate} ${getUnitLabel(rateUnitId, currency)}`;
    const showCalculatedRate = showPrice(calculatedRate, currency);
    const isCustom = calculatedRate !== calculatedRateParent;
    const isTooltip = rateUnitId === 'percent' || calculatedRate !== rate;

    return isTooltip ? (
        <Tooltip title={`${showRate} -> ${showCalculatedRate}`}>
            <span className={isCustom ? StylesItem.customRate : StylesItem.defaultRate}>{showCalculatedRate}</span>
        </Tooltip>
    ) : (
        <span className={isCustom ? StylesItem.customRate : StylesItem.defaultRate}>{showCalculatedRate}</span>
    );
};
